import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import HeroSection from "./components/HeroSection";
import FocusSection from "./components/FocusSection";
import EventsSection from "./components/EventsSection";
import TimelineSection from "./components/TimelineSection";
import CategoriesSection from "./components/CategoriesSection";
import RankingSection from "./components/RankingSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <FocusSection />
        <EventsSection />
        <TimelineSection />
        <CategoriesSection />
        <RankingSection />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}